import { Typography } from '@release/ui/Typography';
import { FieldError } from 'react-hook-form';

interface ErrorTextProps {
  error?: FieldError;
}
export const ErrorText: React.FC<ErrorTextProps> = ({ error }) => {
  {
    return (
      error && (
        <Typography size="rat" className="text-sem-l-text-error">
          {error.message}
        </Typography>
      )
    );
  }
};
